<template>
<div :class="['meal-card-wrapper', { 'screen-lg': onTabletUp }, viewCtx]">
  <div :class="{ swipeable: swipeable }" v-if="platelist">
    <div :class="['meal-card', 'platelist', { 'click-disabled': loading }]" v-for="plate in plates" :key="plate.id" @click="toPlanDetail(plate)">
      <div class="meal-card-hero" :style="`backgroundImage: url(${plate.platelistImage})`">
        <span class="is-snack" v-if="isSnack(dish)">Snack</span>
      </div>
      <div class="meal-card-footer">
        <div class="footer-content" v-numberOfLines="2">{{ truncate(plate.title, 28) }}</div>
        <BaseIcon class="loadingIcon" name="sync" spin v-show="loading" />
      </div>
    </div>
  </div>

  <span v-else>
    <div
      :class="['meal-card', { swipeable: swipeable, 'click-disabled': loading || loadingRecipe === dish.id }, cardType]"
      @click.stop="cardType == 'meal-full' ? toPlanDetail(dish) : showDishDetails(dish)"
    >
      <!-- TODO: Clean this up and maybe break out to new component -->
      <div :class="['meal-card-hero', { 'no-image': noImage }]" v-lazy:background-image="dish.imageUrl || dish.imageurl || dish.imageURL">
        <span class="is-snack" v-if="isSnack(dish)">{{ $t('lblSnack') }}</span>
        <div class="placeholder" v-if="noImage">
          <img src="@assets/images/icon-plate.svg" />
          <h4>Image coming soon</h4>
        </div>

        <span class="icon-wrapper" v-if="cardType != 'meal-full'">
          <transition name="bounce-not-favorite">
            <img v-if="!isFavorite(dish)" key="favorite" :src="openHeartIcon" @click.stop="toggleFavorite(dish)" />
          </transition>
          <transition name="bounce-favorite">
            <img v-if="isFavorite(dish)" key="favorite" :src="heartIcon" @click.stop="toggleFavorite(dish)" />
          </transition>
        </span>

        <div class="leftover-preparation-date" v-if="isLeftoverOption">
          <h4>{{ $t('lblPlannedToCook') }} {{ dish.preparationDate }}</h4>
        </div>
      </div>
      <div class="meal-card-footer">
        <div :id="`footerContent-${dish.id}`" class="footer-content">
          <h3 :class="{ 'center-text': centerTxt(dish.name || dish.title || dish.recipeTitle) }">{{
            truncate(dish.name || dish.title || dish.recipeTitle, 76)
          }}</h3>
          <BaseIcon class="loadingIcon" name="sync" spin v-show="loading || loadingRecipe === dish.id" />
        </div>
        <!-- <span v-if="isLeftoverOption">
          <BaseButton type="button" class="btn-secondary btn-ghost btn-small" :disabled="isAddBtnDisabled" v-if="!summary" @click.stop="add">{{
            $t('calender.buttonLeftOver')
          }}</BaseButton>
          <BaseButton type="button" class="btn-secondary btn-small remove-leftovers" :disabled="isRemoveBtnDisabled" v-if="summary" @click.stop="remove"
            >Using</BaseButton
          >
        </span> -->
        <span class="btn-container" v-if="cardType !== 'meal-full' && !hideButton">
          <BaseButton type="button" class="btn-secondary btn-ghost btn-small" v-if="!summary" @click.stop="add">{{ $t('btnAddToPlan') }}</BaseButton>
          <BaseButton type="button" class="btn-ghost btn-danger" :disabled="isRemoveBtnDisabled" v-if="summary" @click.stop="remove">
            {{ $t('lblRemove') }}
            <span v-if="cardType === 'minimal'">{{ $t('lblRecipe') }}</span>
          </BaseButton>
        </span>
      </div>
    </div>
  </span>
</div>
</template>

<script>
import _ from 'lodash';
import store from '@state/store';
import moment from 'moment';
import utils from '@src/utils/utils';
import { planMixin } from 'planMixin';
import { shareMixin } from 'shareMixin';
import { numberOfLines } from '../../../directives/truncateDirective';
import Leanplum from 'leanplum-sdk';
import {
  authComputed,
  errorsComputed,
  dishesMethods,
  favoritesComputed,
  favoritesMethods,
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  groceryListMethods,
  mainComputed,
  mainMethods,
  planComputed,
  planMethods,
  platelistMethods,
  primaryNavComputed,
  primaryNavMethods,
} from '@state/helpers';

export default {
  mixins: [planMixin, shareMixin],
  directives: { numberOfLines },
  components: {},
  props: {
    appliedMealtime: {
      type: String,
      required: false,
    },
    cardType: {
      type: String,
      required: false,
    },
    dish: {
      type: Object,
      required: false,
    },
    isEmbed: {
      type: Boolean,
      required: false,
    },
    platelist: {
      type: Array,
      required: false,
    },
    summary: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      defalt: false,
    },
    swipeable: {
      type: Boolean,
      default: false,
    },
    isLeftoverOption: {
      type: Boolean,
      default: false,
    },
    navigateHigherWhenDone: {
      type: Boolean,
      default: false,
    },
    loadingRecipe: {
      type: String | null,
      default: false,
    },
    onTabletUp: {
      type: Boolean,
    },
    viewCtx: {
      type: String,
    },
  },
  data() {
    return {
      heartIcon: require('@assets/images/icon-heart.svg'),
      openHeartIcon: require('@assets/images/icon-heart-o.svg'),
      isAddBtnDisabled: false,
      isRemoveBtnDisabled: false,
      componentKey: 0,
      didOpenNavigateDeeper: false,
      loading: false,
    };
  },
  computed: {
    ...authComputed,
    ...errorsComputed,
    ...planComputed,
    ...favoritesComputed,
    ...kitchenDrawerComputed,
    ...mainComputed,
    ...primaryNavComputed,
    dishType() {
      switch (this.dish.dishType || this.dish.type) {
        case 'm':
          return 'meal';
          break;
        case 'r':
          return 'recipe';
          break;
        default:
          break;
      }
    },
    dishTypeShort() {
      return this.dish.dishType || this.dish.type;
    },
    plates() {
      return this.platelist.filter((item) => item.isfeatured === false);
    },
    noImage() {
      return !this.dish.imageUrl && !this.dish.imageurl && !this.dish.imageURL;
    },
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
  },
  mounted() {},
  methods: {
    ...dishesMethods,
    ...favoritesMethods,
    ...groceryListMethods,
    ...kitchenDrawerMethods,
    ...mainMethods,
    ...planMethods,
    ...platelistMethods,
    ...primaryNavMethods,
    buildDishPayload() {
      const selectedDaySlot = this.selectedDaySlot || this.dailySummary;
      const mealTime = this.appliedMealtime ? this.getMealTime(this.appliedMealtime) : selectedDaySlot.mealTime;

      return {
        date: selectedDaySlot.day.dateString,
        planDayId: selectedDaySlot.day.id,
        mealId: this.dishType === 'meal' ? this.dish.id : null,
        recipeId: this.dishType === 'recipe' ? this.dish.id || this.dish.recipeId : null,
        planMealTime: mealTime,
        useLeftovers: this.isLeftoverOption ? true : false,
      };
    },
    async setDailSummaryValues() {
      const clientToday = new Date();
      await this.getPlanGridByWeekOffset({ today: utils.setToMidNight(clientToday).toISOString(), isPremium: true, weekOffset: 0 });

      const dateString = this.dailySummary.day.dateString.substring(0, this.dailySummary.day.dateString.indexOf('T'));
      this.setDailySummary({
        day: this.dailySummary.day,
        planDays: this.currentPlan.planDays,
        selectedDate: dateString,
      });
    },
    async addDishViaPlanSummary() {
      (await this.onTabletUp) ? this.toggleDrawer() : this.toggleDrawer({ desiredState: 'open' });
      this.setDailSummaryValues();
      this.navigateDeeper({
        title: 'Add Recipe',
        component: 'PlanSummary',
        context: 'drawerModal',
      });
    },
    async add() {
      this.isRemoveBtnDisabled = false;
      this.isAddBtnDisabled = true;

      if (this.selectedDaySlot) {
        this.showLoader(this.$t('lblAddingDishToPlan'));

        if ((!this.navigateHigherWhenDone && !this.isLeftoverOption) || !this.onTabletUp) {
          await this.toggleDrawer();
        }

        await this.addDish(this.buildDishPayload());

        Leanplum.track('Nutrition', {
          action: 'add recipe',
          os: 'web',
          recipe_id: this.dish.id || this.dish.recipeId,
          recipe_label: this.dish.name,
        });

        await this.getPlanGridByWeekOffset({
          today: this.selectedDaySlot.day.dateString,
          isPremium: true,
          weekOffset: 0,
        }).finally(() => {
          this.isAddBtnDisabled = false;
          if (this.onTabletUp === undefined || this.onTabletUp) {
            return this.getGroceryList();
          }
        });

        if (this.navigateHigherWhenDone) {
          this.navigateHigher();
        }

        this.hideLoader();
      } else {
        this.setDishToAdd(
          this.dishType === 'meal'
            ? {
                mealId: this.dish.id,
                recipeId: null,
                name: this.dish.name || this.dish.title,
              }
            : {
                mealId: null,
                recipeId: this.dish.id,
                name: this.dish.name || this.dish.title,
              }
        );

        if (this.currentPrimaryView.primary && this.currentPrimaryView.component === 'Recipes') {
          if (this.isPlanEmpty) {
            this.setIsPlanEmpty();
          }
          this.resetPrimaryStack();
        } else {
          this.addDishViaPlanSummary();
        }
      }
    },
    updateSummary(updatedMacros) {
      const type = this.dish.dishType === 'm' ? 'meals' : 'recipes';
      const summaryClone = _.cloneDeep(this.dailySummary);
      const remainingDishes = summaryClone.day[this.appliedMealtime][type].filter((dish) => dish.dishId !== this.dish.dishId);

      // updateMacros is returning a delta for the dish added or removed.
      const macroNutritionDigest = summaryClone.day.aggregatedNutritionDigest.macroNutritionDigest;

      if (!_.isEmpty(updatedMacros.macroNutritionDigest)) {
        macroNutritionDigest.calories.value -= updatedMacros.macroNutritionDigest.calories.value;
        macroNutritionDigest.carbs.value -= updatedMacros.macroNutritionDigest.carbs.value;
        macroNutritionDigest.fat.value -= updatedMacros.macroNutritionDigest.fat.value;
        macroNutritionDigest.protein.value -= updatedMacros.macroNutritionDigest.protein.value;

        const macroNutrientTotal = macroNutritionDigest.carbs.value + macroNutritionDigest.fat.value + macroNutritionDigest.protein.value;

        macroNutritionDigest.carbs.macroPercentage = macroNutritionDigest.carbs.value
          ? Math.round((macroNutritionDigest.carbs.value / macroNutrientTotal) * 100)
          : 0;
        macroNutritionDigest.fat.macroPercentage = macroNutritionDigest.fat.value ? Math.round((macroNutritionDigest.fat.value / macroNutrientTotal) * 100) : 0;
        macroNutritionDigest.protein.macroPercentage = macroNutritionDigest.protein.value
          ? Math.round((macroNutritionDigest.protein.value / macroNutrientTotal) * 100)
          : 0;
      }

      summaryClone.day[this.appliedMealtime][type] = remainingDishes;

      this.setDailySummary(summaryClone);
    },
    async remove() {
      this.setUserAction('removeDish');
      this.isRemoveBtnDisabled = true;
      this.$emit('remove-dish', { mealtime: this.appliedMealtime, dish: this.dish });

      const updatedMacros = await this.removeDish(this.dish.dishId);

      Leanplum.track('Nutrition', {
        action: 'remove recipe',
        os: 'web',
        recipe_id: this.dish.dishId || this.dish.dishId || this.dish.recipeId,
        recipe_label: this.dish.name,
      });

      if (updatedMacros) {
        this.updateSummary(updatedMacros);
      }
    },
    async toPlanDetail(plate) {
      this.loading = true;
      if (this.didOpenNavigateDeeper) {
        return;
      }
      this.setDidOpenNavigateDeeper(true);
      if (this.loggedIn) {
        await this.getPlatelistDays(plate.id);
      } else {
        plate = await this.getPublicPlatelistSummary(plate.id);
      }
      this.loading = false;
      const component = this.loggedIn ? 'PlanDetail' : 'PlanDetailPublic';
      this.navigateDeeper({
        title: this.$t('lblPlanDetails'),
        component: component,
        data: plate,
      });

      if (this.onTabletUp && !this.isOpen) {
        this.toggleDrawer();
      }

      this.updateShareableUrl(component, plate);
    },
    setDidOpenNavigateDeeper(value) {
      // prevents from opening view multiple times with multiples clicks
      this.didOpenNavigateDeeper = value;
      setTimeout(() => {
        if (value) {
          this.didOpenNavigateDeeper = false;
        }
      }, 700);
    },
    isFavorite(dish) {
      if (this.favoriteDishesMap[this.dishTypeShort]) {
        return (this.favoriteDishesMap[this.dishTypeShort][this.dish.id] || this.favoriteDishesMap[this.dishTypeShort][this.dish.recipeId]) === true
          ? true
          : false;
      }
      return false;
    },
    isSnack(dish) {
      return dish && dish.id && dish.mealTimes && dish.mealTimes.length > 0 && dish.mealTimes.find((mt) => mt.id === 4);
    },
    toggleFavorite(dish) {
      if (this.isFavorite(dish)) {
        this.removeFavorite({ dishType: this.dishTypeShort, dishId: this.dish.id || this.dish.recipeId });
      } else {
        this.addFavorite({ dishType: this.dishTypeShort, dishId: this.dish.id || this.dish.recipeId });

        Leanplum.track('Nutrition', {
          action: 'favorite recipe',
          os: 'web',
          recipe_id: this.dish.id || this.dish.recipeId,
          recipe_label: this.dish.name,
        });
      }
    },
    showDishDetails(dish) {
      this.$emit('showDishDetails', dish);
    },
    truncate(name, charNum) {
      return name.length > charNum ? name.substring(0, charNum) + '...' : name;
    },
    centerTxt(name) {
      return name && name.length <= 30 ? true : false;
    },
  },
  watch: {
    retry(prevVal, newVal) {
      if (this.userAction === 'removeDish') {
        this.remove();
        this.componentKey += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.swipeable {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-points-y: repeat(300px);
  scroll-snap-type: mandatory;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
}

.meal-card {
  border: 1px solid $base-border-color;
  border-radius: $base-border-radius;
  flex: 1;
  height: 26.9rem;
  margin-bottom: 1rem;
  .is-snack {
    background-color: $color-meal-card-snack-bg;
    border: 1px solid $base-border-color;
    border-radius: $base-border-radius;
    color: white;
    left: 5px;
    padding: 5px;
    position: relative;
    top: 10px;
    z-index: 0.5;
  }

  .meal-card-hero {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-top-left-radius: $base-border-radius;
    border-top-right-radius: $base-border-radius;
    height: 19.6rem;
    overflow: hidden;
    position: relative;

    &.no-image {
      align-items: center;
      background-color: lighten($color-secondary, 35);
      display: flex;
      justify-content: center;

      .placeholder {
        display: flex;
        flex-direction: column;
        text-align: center;
        text-transform: uppercase;
      }

      h4 {
        color: $color-secondary;
        margin-top: 1rem;
      }
    }

    &:hover {
      cursor: pointer;
    }

    .leftover-preparation-date {
      background-color: rgba($color-white, 0.8);
      bottom: 0;
      left: 0;
      padding: 0.5rem 2rem;
      position: absolute;
      right: 0;

      @include media('xl', null) {
        padding-bottom: 0;
        padding-top: 0;
      }

      h4 {
        color: darken($color: $color-leftovers-available, $amount: 15);
        margin: 0;
      }
    }

    .icon-wrapper {
      align-items: center;
      background-color: $color-meal-card-hero-icon-bg;
      border: 1px solid $base-border-color;
      border-radius: $size-card-meal-border-radius;
      display: flex;
      height: 4.2rem;
      justify-content: center;
      padding-top: 0.5rem;
      position: absolute;
      right: 1rem;
      top: 1rem;
      width: 4.2rem;

      img {
        position: absolute;
      }

      .bounce-favorite-enter-active {
        animation: bounce-in 0.3s;
        transition: opacity 0.3s;
      }
      .bounce-favorite-leave-active {
        animation: bounce-out 0.1s reverse;
        transition: opacity 0.3s;
      }
      .bounce-favorite-enter,
      .bounce-favorite-leave-to {
        opacity: 0;
      }

      .bounce-not-favorite-enter-active {
        // animation: bounce-in .5s;
        transition: opacity 0.5s;
      }
      .bounce-not-favorite-leave-active {
        // animation: bounce-out .5s reverse;
        transition: opacity 0.5s;
      }

      .bounce-not-favorite-enter,
      .bounce-not-favorite-leave-to {
        opacity: 0;
      }

      @keyframes bounce-in {
        0% {
          transform: scale(0);
        }
        50% {
          transform: scale(1.3);
        }
        100% {
          transform: scale(1);
        }
      }

      @keyframes bounce-out {
        0% {
          transform: scale(0.9);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }

  .meal-card-footer {
    align-items: center;
    background: transparent;
    border-bottom-left-radius: $base-border-radius;
    border-bottom-right-radius: $base-border-radius;
    bottom: 0;
    display: flex;
    height: 90px;
    justify-content: space-between;
    max-height: 7.1rem;
    overflow: hidden;
    padding: 2rem 1.1rem 1.5rem 2rem;
    width: 100%;

    .footer-content {
      align-items: center;
      display: flex;
      flex: 1;
      justify-content: space-between;
      line-height: 1.2;

      h3 {
        font-size: 1.5rem;
        line-height: 2.5625rem;
        overflow: hidden;
        text-overflow: ellipsis;

        &.center-text {
          align-items: center;
          display: flex;
        }
      }
      svg {
        transform: scale(2);
      }
    }

    button {
      &:active {
        background-color: $color-action;
        border-color: $color-action;
        box-shadow: none;
        color: $color-black;
      }

      &:focus {
        box-shadow: none;
      }
    }

    .btn-ghost {
      &:active {
        background-color: $color-white;
        border-color: $color-action;
        box-shadow: none;
        color: $color-action;
      }
    }

    .btn-danger {
      color: #dc3545;
    }
  }

  &.meal,
  &.meal-full {
    margin-bottom: 0.5rem;
    position: relative;
  }

  &.meal-full {
    height: 37rem;
    .meal-card-hero {
      border-bottom-left-radius: $base-border-radius;
      border-bottom-right-radius: $base-border-radius;
      height: 100%;

      &::before {
        background-color: $color-meal-card-full-hero-overlay;
        border-radius: $base-border-radius;
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .meal-card-footer {
      background-color: $color-meal-card-footer-bg;
      bottom: 0;
      max-height: 10rem;
      padding: 0 2rem;
      position: absolute;

      .footer-content {
        h3 {
          font-family: $meal-card-full-font-family;
          font-size: 2rem;
        }

        p {
          font-size: 1.7rem;
        }
      }

      .button {
        display: none;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

  &.minimal {
    height: 19rem;
    margin-right: 1rem;
    overflow: hidden;
    scroll-snap-align: center;
    width: 22.5rem;

    .meal-card-hero {
      height: 11.9rem;
    }

    .meal-card-footer {
      align-items: flex-start;
      flex-direction: column;
      height: 8rem;
      max-height: unset;
      padding: 0 0 1rem 0;

      .footer-content {
        display: flex;
        font-size: 1.4rem;
        justify-content: center;
        min-width: 0;

        h3 {
          align-self: center;
          box-sizing: border-box;
          display: block;
          font-weight: normal;
          overflow: hidden;
          padding-left: 1rem;
          padding-right: 0.5rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 22.5rem;
        }
      }

      .btn-container {
        bottom: -2.1rem;
        display: block;
        margin: 0 auto;
        text-align: center;
      }

      .button {
        border: 0;
        font-weight: bold;

        &:hover {
          box-shadow: none;
        }
      }

      .button span {
        font-size: 1.4rem;
      }
    }
  }

  &.platelist {
    height: 13rem;
    margin-right: 0.5rem;
    min-width: 16rem;
    scroll-snap-align: center;

    .meal-card-hero {
      height: 8rem;
    }

    .meal-card-footer {
      height: auto;
      padding: 0.8rem 1.5rem 0;

      .footer-content {
        display: flex;
        font-size: 1.4rem;
        justify-content: center;
      }
    }
  }
}

.meal-card-wrapper.screen-lg {
  flex: 0 0 auto;
  flex-basis: 48%;
  margin-right: 0.5rem;

  // iPad Pro up
  @include media('xxl', null) {
    flex-basis: 31%;
  }

  .meal-card-footer {
    // iPad up
    @include media('xl', null) {
      padding-left: 1.1rem;
    }

    .button.btn-small {
      // iPad Pro up
      @include media('xxl', null) {
        padding: 0.8rem;
      }
    }
  }

  // stylelint-disable no-descending-specificity
  .footer-content h3 {
    line-height: 1.2;

    // iPad up
    @include media('xl', null) {
      font-size: 1.3rem;
    }
  }

  &.drawerModal {
    flex-basis: 100%;
    margin-right: 0;
  }
}
.loadingIcon {
  @extend %typography-xlarge;

  display: block;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
.click-disabled {
  pointer-events: none;
}
</style>
